import styled from '@emotion/styled';

const CommentHeader = styled('header')({
  marginBottom: 4,
  display: 'flex',
  alignItems: 'center',
});

export default CommentHeader;
